import { Injectable } from '@angular/core';
import { Actions as EffectActions, createEffect, ofType } from '@ngrx/effects';
import { ActionType } from './store/actions/product-groups.actions';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import * as Actions from './store/actions/product-groups.actions';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

import { ProductGroupsService } from './product-groups.service';
import { ProductGroup } from '../models/product-group.model';

@Injectable({
  providedIn: 'root'
})
export class ProductGroupsEffects {

  url = 'https://localhost:44358';

  constructor(
    private actions$: EffectActions,
    private http: HttpClient,
    private productGroupsService: ProductGroupsService
  ) { }


  
  fetchProductGroupsRequest = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_PRODUCTGROUPS),
      mergeMap((action: Actions.FetchProductGroups) => {

        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.get<ProductGroup[]>(this.url + '/api/ProductGroups', httpOptions)
          .pipe(
            mergeMap((response: any) => {
              return ([
                new Actions.FetchProductGroupsSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchProductGroupsFailed(err));
            })

          );
      })
    ));

  // @Effect()
  // fetchProductGroupsByCompanyIdRequest = this.actions$
  //   .pipe(
  //     ofType(ActionType.FETCH_PRODUCTGROUPS_BY_COMPANYID),
  //     mergeMap((action: Actions.FetchProductGroupsByCompanyId) => {

  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.get<ProductGroup[]>(this.url + '/api/ProductGroups/GetProductGroupsByCompanyId/' + action.companyId, httpOptions)

  //         .pipe(
  //           mergeMap((response: any) => {
  //             return ([
  //               new Actions.FetchProductGroupsByCompanyIdSuccess(response)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.FetchProductGroupsByCompanyIdFailed(err));
  //           })

  //         );
  //     })
  //   );

  // New syntax
  fetchProductGroupsByCompanyIdRequestFirebase$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(ActionType.FETCH_PRODUCTGROUPS_BY_COMPANYID),
        mergeMap((action: Actions.FetchProductGroupsByCompanyId) => {

          return this.productGroupsService.getProductGroupsByCompanyId$(action.companyId)
            .pipe(
              mergeMap((response: any) => {
                console.log('fetchProductGroupsRequestByCompanyId createEffect syntax...', response);
                return ([
                  new Actions.FetchProductGroupsByCompanyIdSuccess(response)
                ]);
              }
              ),
              catchError(err => {
                console.log('Handling error locally and rethrowing it...', err);
                return of(new Actions.FetchProductGroupsByCompanyIdFailed(err));
              })

            );
        })
      );
  });


  
  fetchProductGroupsByCompanyIdSiteIdRequestFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_PRODUCTGROUPS_BY_COMPANYIDSITEID),
      mergeMap((action: Actions.FetchProductGroupsByCompanyIdSiteId) => {

        return this.productGroupsService.getProductGroupsByCompanyIdSiteId$(action.companyId, action.siteId)
          .pipe(
            mergeMap((response: any) => {

              console.log('fetchProductGroupsRequestByCompanyIdSiteId...', response);
              return ([
                new Actions.FetchProductGroupsByCompanyIdSiteIdSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchProductGroupsByCompanyIdSiteIdFailed(err));
            })

          );
      })
    ));

  
  addProductGroupFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.ADD_PRODUCTGROUP),
      mergeMap(async (action: Actions.AddProductGroup) => {

        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        let productGroup = action.productGroup;

        await this.productGroupsService.addProductGroupFirebase$(productGroup)
          .then((response: any) => {
            // productGroup.id = response.id;
            productGroup = Object.assign({}, productGroup, { id: response.id });

            console.log('productGroup...', productGroup);
          }).catch((err: any) => {
            // productGroup.id = null;
            console.log('err in catch...', err);
          });

        if (productGroup.id !== null) {
          return new Actions.AddProductGroupSuccess(productGroup);
        } else {
          return new Actions.AddProductGroupFailed();
        }
      })
    ));

  
  updateProductGroupFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.UPDATE_PRODUCTGROUP),
      mergeMap((action: Actions.UpdateProductGroup) => {

        const productGroup = action.productGroup;

        return this.productGroupsService.updateProductGroupFirebase$(productGroup)
          .pipe(
            mergeMap((response: any) => {

              console.log('response updateProductGroupFirebase...', productGroup);
              return ([
                new Actions.UpdateProductGroupSuccess(productGroup.id!, productGroup)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.UpdateProductGroupFailed());
            })

          );
      })
    ));

  // @Effect()
  // deleteBug = this.actions$
  //   .pipe(
  //     ofType(ActionType.DELETE_PRODUCTGROUP),
  //     mergeMap((action: Actions.DeleteProductGroup) => {
  //       const id = action.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.delete<number>(this.url + '/api/ProductGroups/' + id, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('response...', response);
  //             return ([
  //               new Actions.DeleteProductGroupSuccess(response.id)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.DeleteProductGroupFailed());
  //           })

  //         );
  //     })
  //   );

  
  destroyChannelFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.DESTROY_PRODUCTGROUP),
      mergeMap(async (action: Actions.DestroyProductGroup) => {

        const id = action.id;

        await this.productGroupsService.destroyProductGroupFirebase$(id)
          .then((response: any) => {
            console.log('response...', response);
          }).catch((err: any) => {
            console.log('err in catch...', err);
          });

        if (id !== null) {
          return new Actions.DestroyProductGroupSuccess(id);
        } else {
          return new Actions.DestroyProductGroupFailed();
        }
      })
    ));

  
  deleteDeleteProductFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.DELETE_PRODUCTGROUP),
      mergeMap(async (action: Actions.DeleteProductGroup) => {

        const id = action.id;

        await this.productGroupsService.deleteProductGroupFirebase$(id)
          .then((response: any) => {
            console.log('response...', response);
          }).catch((err: any) => {
            console.log('err in catch...', err);
          });

        if (id !== null) {
          return new Actions.DeleteProductGroupSuccess(id);
        } else {
          return new Actions.DeleteProductGroupFailed();
        }
      })
    ));

  // @Effect()
  // destroyProductGroup = this.actions$
  //   .pipe(
  //     ofType(ActionType.DESTROY_PRODUCTGROUP),
  //     mergeMap((action: Actions.DestroyProductGroup) => {
  //       const id = action.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.delete<number>(this.url + '/api/ProductGroups/' + id, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('response...', response);
  //             return ([
  //               new Actions.DestroyProductGroupSuccess(response.id)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.DestroyProductGroupFailed());
  //           })

  //         );
  //     })
  //   );

  // @Effect()
  // updateBug = this.actions$
  //   .pipe(
  //     ofType(ActionType.UPDATE_PRODUCTGROUP),
  //     mergeMap((action: Actions.UpdateProductGroup) => {

  //       const message = action.productGroup;
  //       const id = action.productGroup.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       const bug = action.productGroup;

  //       return this.http.put<ProductGroup>(this.url + '/api/ProductGroups/' + id, bug, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {

  //             console.log('response updateBug...', bug);
  //             return ([
  //               new Actions.UpdateProductGroupSuccess(bug)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.UpdateProductGroupFailed());
  //           })

  //         );
  //     })
  //   );
}
